import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPsaContactsByCompanyId } from 'services/pod';

interface IThunkGetPsaContactsByCompanyIdPayload {
  psaId: number;
  companyId: number;
  start?: number;
  end?: number;
  searchQuery?: string;
}

export const ThunkGetPsaContactsByCompanyId = createAsyncThunk(
  'pod/getPsaContactsByCompanyId',
  async ({ psaId, companyId, start, end, searchQuery }: IThunkGetPsaContactsByCompanyIdPayload) => {
    const r = await getPsaContactsByCompanyId(psaId, companyId, start, end, searchQuery);
    return {
      data: r.data,
      totalCount: r.headers['x-total-count'],
      start,
      end,
    };
  },
);
